import { ApolloClient, HttpLink, ApolloLink, InMemoryCache ,gql } from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getUrl } from "../variables/host";
import { getTokenFromUrl } from "../utils/helper-functions/getTokenFromUrl";
import { setContext } from "@apollo/client/link/context";
import * as subscriptions from './subscriptions'
import { sendOpenSearchLogs } from "utils/helper-functions/send-open-search-logs";
import { createClient } from "graphql-ws";

const wsUrl = getUrl("graphqlDomain").replace(/^https/, 'wss');

const httpLink = new HttpLink({
    uri: getUrl("graphqlDomain"),
  });

  const wsLink = new GraphQLWsLink(
    createClient({
      url: wsUrl,
      connectionParams: {
        Authorization: getTokenFromUrl('graphql')
      }
    })
  );


const authLink = setContext((_, { headers }) => {  
    return {
      headers: {
        ...headers,
        Authorization: getTokenFromUrl('graphql'),
      },
    };
  });

const splitLink = ApolloLink.split(
    ({ operationName }) => {
      return operationName === "PreviewThemeChanged" || operationName === "PreviewPageStateChanged";
    },
    wsLink,
    authLink.concat(httpLink)
  );

const createApolloClient = () => {
    return new ApolloClient({
        link: splitLink,
        cache: new InMemoryCache(),
      });
}

const getApolloQuery = async ({ 
    query = '', 
    client, 
    variables,
    history
}: { 
    query: string, 
    client: ApolloClient,
    variables?: any,
    history: any
}) => {
    try {
        const {data = {}} = await client.query({ query: gql(query), fetchPolicy: 'no-cache', ...(variables && { variables }) });
        if(data) {
            return data;
        } else {
            const errorText = `Can't get ${query} query as its undefined`;

            console.error(errorText);
            return {};
        }
    } catch(err) {
        const errorText = `Can't get ${query} query:`;

        sendOpenSearchLogs({
            event_group: "cashier_get_amplify_query",
            error_data: {
                error: {
                    message: errorText,
                    stack: err
                }
            }
        });

        if(err.message.includes('Forbidden resource')) {
            history.push("error_7");
            return null;
        }

        console.error(errorText, err);
    }
};

const setSubscription = async(client: ApolloClient, query: string = '', callbackSuccess, callbackError) => {
    return client.subscribe({query: gql(subscriptions[query])})
        .subscribe({
            next: ({ data }) => {
                if (typeof callbackSuccess === 'function') {
                    callbackSuccess(data);
                }
            }, 
            error: (error) => {
                const errorText = 'Error to set subscription';

                sendOpenSearchLogs({
                    event_group: "cashier_set_subscription",
                    error_data: {
                        error: {
                            message: errorText,
                            stack: { query, SubscriptionStateChangedError: error }
                        }
                    }
                });
    
                console.error(errorText, {query, SubscriptionStateChangedError: error});
                if (typeof callbackError === 'function') {
                    callbackError(error);
                };
            }
        }
    );
}

const unsubscribeAll = (subscriptions = {}) => {
    Object.keys(subscriptions).forEach(async (subscription_key) => {
        subscriptions[subscription_key]?.unsubscribe();
    })
}

export {
    createApolloClient,
    getApolloQuery,
    setSubscription,
    unsubscribeAll
}
